import { Box, Fade, Icon, Popper, Typography } from '@mui/material'
import AdxButton from 'components/custom/AdxButton'
import AdxInfoModal from 'components/reusable/modal/AdxInfoModal'
import { useState } from 'react'
import { useMutation, useQueryClient } from 'react-query'
import { useNavigate } from 'react-router-dom'
import {
  updateApplicant,
  updateCandidateStatus,
} from 'services/api/modules/recruitment/job-application'
import useOpenClose from 'services/hooks/useOpenClose'

const DrawerHeaderButtonState = ({
  candidate_id,
  id,
  type,
  changeApplicantDetail,
  applicantName,
  email,
  profile_picture,
  setIsDataChange,
  profile_type,
}) => {
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  //modal state
  const rejectCandidateModalState = useOpenClose(false)
  const offerCandidateModalState = useOpenClose(false)
  const hiredModalState = useOpenClose(false)
  const noEmailModalState = useOpenClose(false)

  // more option popper state (from MUI ) (only for shortlisted status )
  const [open, setOpen] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null)
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
    setOpen((previousOpen) => !previousOpen)
  }
  const canBeOpen = open && Boolean(anchorEl)

  // handling
  const handleOfferPopperChange = () => {
    offerCandidateModalState.handleOpen()
    setOpen(false)
  }
  const handleRejectPopperChange = () => {
    rejectCandidateModalState.handleOpen()
    setOpen(false)
  }
  //   api call
  const {
    mutate: updateCandidateMutate,
    isLoading: updateCandidateIsLoading,
    isError: updateCandidateIsError,
  } = useMutation((data) => updateCandidateStatus(id, data), {
    onSuccess: async () => {
      //close modal if success
      if (rejectCandidateModalState.isOpen) {
        rejectCandidateModalState.handleClose()
      }
      if (offerCandidateModalState.isOpen) {
        offerCandidateModalState.handleClose()
      }
      if (hiredModalState.isOpen) {
        hiredModalState.handleClose()
      }

      /** 
       This is still not optimized. This is just a workaround so that
       user dont need to wait to long until the modal is closed. The
       data will be refetch in background. UX is compromised.
      **/
      // Refetch in the background
      queryClient.invalidateQueries('getAllApplicant')
      queryClient.invalidateQueries('jobstats')

      // change data that is selected at the talent drawer
      setIsDataChange(true)
    },
    onError: (error) => {
      console.log(error)
      //close modal if success
      if (rejectCandidateModalState.isOpen) {
        rejectCandidateModalState.handleClose()
      }
      if (offerCandidateModalState.isOpen) {
        offerCandidateModalState.handleClose()
      }
      if (hiredModalState.isOpen) {
        hiredModalState.handleClose()
      }
    },
  })

  const {
    mutate: addToCartMutate,
    isLoading: addToCartIsLoading,
    isError: addToCartIsError,
  } = useMutation((id) => updateApplicant(id, 'add-to-cart'), {
    onSuccess: async (response) => {
      await queryClient.invalidateQueries('getAllApplicant')
      console.log(response)
      queryClient.invalidateQueries('getCart')
      queryClient.resetQueries('getCart')
      changeApplicantDetail(response.data)
    },
    onError: (error) => {
      console.log(error)
    },
  })

  if (type === 'shortlist')
    return (
      <>
        <Box
          display="flex"
          justifyContent="space-between"
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            width: 1,
            gap: 1,
          }}
        >
          <AdxButton
            variant={'outlined'}
            sx={{
              width: '50%',
            }}
            isLoading={updateCandidateIsLoading}
            // disabled={!email}
            onClick={() => {
              if (!email) {
                noEmailModalState.handleOpen()
              } else {
                updateCandidateMutate({ job_ad_candidate_status_id: 2 })
              }
            }}
          >
            Shortlist
          </AdxButton>

          <AdxButton
            variant={'outlined-destructive'}
            sx={{
              width: '50%',
            }}
            onClick={rejectCandidateModalState.handleOpen}
          >
            Reject
          </AdxButton>
        </Box>
        {updateCandidateIsError && (
          <Box
            display="flex"
            alignItems="center"
            columnGap={2}
            sx={{
              width: '100%',
            }}
            bgColor="gray-background.main"
          >
            <Typography variant="body1" color="error.main">
              An error has occured. Please try again
            </Typography>
          </Box>
        )}
        {/* modal  */}
        {rejectCandidateModalState.isOpen && (
          <RejectCandidateModal
            open={rejectCandidateModalState.isOpen}
            onClose={rejectCandidateModalState.handleClose}
            isLoading={updateCandidateIsLoading}
            onClick={() => updateCandidateMutate({ job_ad_candidate_status_id: 6 })}
            isError={updateCandidateIsError}
          />
        )}
        {noEmailModalState.isOpen && (
          <NoEmailModal open={noEmailModalState.isOpen} onClose={noEmailModalState.handleClose} />
        )}
      </>
    )
  if (type === 'add to cart')
    return (
      <>
        <Box
          display="flex"
          columnGap={1}
          justifyContent="space-between"
          sx={{
            width: '98%',
          }}
        >
          <AdxButton
            sx={{
              width: '80%',
              gap: 1,
            }}
            isLoading={addToCartIsLoading}
            onClick={() => {
              addToCartMutate(id)
            }}
          >
            <Icon>shopping_cart</Icon>
            Add to cart
          </AdxButton>

          <AdxButton
            variant={'outlined-destructive'}
            sx={{
              width: '20%',
            }}
            onClick={rejectCandidateModalState.handleOpen}
          >
            Reject
          </AdxButton>
        </Box>
        {addToCartIsError && (
          <Box
            display="flex"
            alignItems="center"
            columnGap={2}
            sx={{
              width: '100%',
            }}
            bgColor="gray-background.main"
          >
            <Typography variant="body1" color="error.main">
              An error has occured. Please try again
            </Typography>
          </Box>
        )}
        {/* modal  */}
        {rejectCandidateModalState.isOpen && (
          <RejectCandidateModal
            open={rejectCandidateModalState.isOpen}
            onClose={rejectCandidateModalState.handleClose}
            isLoading={updateCandidateIsLoading}
            onClick={() => updateCandidateMutate({ job_ad_candidate_status_id: 7 })}
            isError={updateCandidateIsError}
          />
        )}
      </>
    )
  if (type === 'view in cart')
    return (
      <>
        <Box
          display="flex"
          columnGap={1}
          justifyContent="space-between"
          sx={{
            width: 1,
          }}
        >
          <AdxButton
            variant={'outlined'}
            sx={{
              width: '80%',
            }}
            onClick={() => navigate('/app/recruitment/cart')}
          >
            <Icon>shopping_cart</Icon>
            View in cart
          </AdxButton>

          <AdxButton
            variant={'outlined-destructive'}
            sx={{
              width: '20%',
            }}
            onClick={rejectCandidateModalState.handleOpen}
          >
            Reject
          </AdxButton>
        </Box>
        {/* modal  */}
        {rejectCandidateModalState.isOpen && (
          <RejectCandidateModal
            open={rejectCandidateModalState.isOpen}
            onClose={rejectCandidateModalState.handleClose}
            isLoading={updateCandidateIsLoading}
            onClick={() => updateCandidateMutate({ job_ad_candidate_status_id: 7 })}
            isError={updateCandidateIsError}
          />
        )}
      </>
    )
  if (type === 'hired')
    return (
      <>
        <Box
          display="flex"
          justifyContent="space-between"
          bgcolor="default-background.main"
          sx={{
            width: '100%',
          }}
          py={1.5}
          px={2}
        >
          <Typography
            display="flex"
            alignItems="center"
            variant="body1"
            color="light-gray-text.main"
            gap={1}
          >
            <Icon sx={{ color: 'positive.main' }}>check_circle</Icon>
            Hired
          </Typography>
          {/* <Typography
            variant="body1"
            color="alternate.main"
            onClick={() => updateCandidateMutate({ job_ad_candidate_status_id: 2 })}
            sx={{
              textDecoration: 'underline',
              cursor: 'pointer',
            }}
          >
            Revert
          </Typography> */}
        </Box>
      </>
    )
  if (type === 'rejected')
    return (
      <>
        <Box
          display="flex"
          justifyContent="space-between"
          bgcolor="default-background.main"
          sx={{
            width: '100%',
          }}
          py={1.5}
          px={2}
        >
          <Typography
            display="flex"
            alignItems="center"
            variant="body1"
            color="light-gray-text.main"
            gap={1}
          >
            <Icon sx={{ color: 'error.main' }}>cancel_icon</Icon>
            Rejected
          </Typography>
          {/* <Typography
            variant="body1"
            color="alternate.main"
            onClick={() => updateCandidateMutate({ job_ad_candidate_status_id: 2})}
            sx={{
              textDecoration: 'underline',
              cursor: 'pointer',
            }}
          >
            Revert
          </Typography> */}
        </Box>
      </>
    )
  if (type === 'offer')
    return (
      <>
        <Box
          display="flex"
          columnGap={1}
          justifyContent="space-between"
          sx={{
            width: 1,
          }}
        >
          <AdxButton
            sx={{
              width: '50%',
              gap: 1,
            }}
            // isLoading={addToCartIsLoading}
            // onClick={() => {
            //   addToCartMutate(id)
            // }}
            onClick={offerCandidateModalState.handleOpen}
          >
            <Icon>drafts</Icon>
            Offer candidate
          </AdxButton>
          <AdxButton
            variant={'outlined-destructive'}
            sx={{
              width: '50%',
            }}
            onClick={rejectCandidateModalState.handleOpen}
          >
            Reject
          </AdxButton>
        </Box>
        {updateCandidateIsError && (
          <Box
            display="flex"
            alignItems="center"
            sx={{
              width: '100%',
              gap: 2,
            }}
            bgColor="gray-background.main"
          >
            <Typography variant="body1" color="error.main">
              An error has occured. Please try again
            </Typography>
          </Box>
        )}
        {/* modal  */}
        {offerCandidateModalState.isOpen && (
          <OfferCandidateModal
            open={offerCandidateModalState.isOpen}
            onClose={offerCandidateModalState.handleClose}
            isLoading={updateCandidateIsLoading}
            onClick={() => updateCandidateMutate({ job_ad_candidate_status_id: 4 })}
            isError={updateCandidateIsError}
          />
        )}
        {rejectCandidateModalState.isOpen && (
          <RejectCandidateModal
            open={rejectCandidateModalState.isOpen}
            onClose={rejectCandidateModalState.handleClose}
            isLoading={updateCandidateIsLoading}
            onClick={() => updateCandidateMutate({ job_ad_candidate_status_id: 6 })}
            isError={updateCandidateIsError}
          />
        )}
      </>
    )
  if (type === 'move to hired')
    return (
      <>
        <Box
          display="flex"
          justifyContent="space-between"
          sx={{
            width: 1,
            gap: 1,
          }}
        >
          <AdxButton
            sx={{
              width: '50%',
              gap: 1,
            }}
            // isLoading={addToCartIsLoading}
            // onClick={() => {
            //   addToCartMutate(id)
            // }}
            onClick={hiredModalState.handleOpen}
          >
            Move to hired
          </AdxButton>
          <AdxButton
            variant={'outlined-destructive'}
            sx={{
              width: '50%',
            }}
            onClick={rejectCandidateModalState.handleOpen}
          >
            Move to rejected
          </AdxButton>
        </Box>
        {updateCandidateIsError && (
          <Box
            display="flex"
            alignItems="center"
            columnGap={2}
            sx={{
              width: '100%',
            }}
            bgColor="gray-background.main"
          >
            <Typography variant="body1" color="error.main">
              An error has occured. Please try again
            </Typography>
          </Box>
        )}
        {/* modal  */}
        {rejectCandidateModalState.isOpen && (
          <RejectCandidateModal
            open={rejectCandidateModalState.isOpen}
            onClose={rejectCandidateModalState.handleClose}
            isLoading={updateCandidateIsLoading}
            onClick={() => updateCandidateMutate({ job_ad_candidate_status_id: 6 })}
            isError={updateCandidateIsError}
          />
        )}
        {hiredModalState.isOpen && (
          <HiredModal
            open={hiredModalState.isOpen}
            onClose={hiredModalState.handleClose}
            isLoading={updateCandidateIsLoading}
            onClick={() => updateCandidateMutate({ job_ad_candidate_status_id: 5 })}
            isError={updateCandidateIsError}
          />
        )}
      </>
    )
  if (type === 'schedule interview')
    return (
      <>
        <Box
          display="flex"
          columnGap={1}
          justifyContent="space-between"
          sx={{
            width: '100%',
          }}
        >
          <AdxButton
            sx={{
              width: '50%',
              gap: 1,
            }}
            // isLoading={addToCartIsLoading}
            onClick={() => {
              navigate('/app/recruitment/schedule-interview', {
                state: {
                  applicant_name: applicantName,
                  email,
                  id,
                  profile_picture,
                  candidate_id,
                  profile_type,
                },
              })
            }}
          >
            <Icon>calendar_month</Icon>
            Schedule interview
          </AdxButton>

          <Box
            sx={{
              width: '50%',
            }}
          >
            <AdxButton
              variant={'outlined'}
              sx={{
                width: '100%',
              }}
              size="standard"
              onClick={handleClick}
            >
              More options
              <Icon>{canBeOpen ? 'expand_less' : 'expand_more'} </Icon>
            </AdxButton>
            <Popper
              style={{ zIndex: 9999999999999 }}
              open={open}
              anchorEl={anchorEl}
              placement="bottom-start"
              transition
            >
              {({ TransitionProps }) => (
                <Fade {...TransitionProps} timeout={350}>
                  <Box
                    // right={{ lg: '15px', md: '10px' }}
                    position="absolute"
                    width={{ lg: '270px', md: '150px' }}
                    sx={{
                      backgroundColor: 'white.main',
                      border: 1,
                      borderColor: 'gray-line.main',
                      // width: '250px',
                      // top: '170px',
                      // right: '15px',
                    }}
                  >
                    <Box
                      display="flex"
                      alignItems="center"
                      padding={2}
                      borderBottom={1}
                      borderColor="gray-line.main"
                      columnGap={2}
                      sx={{
                        cursor: 'pointer',
                        '&:hover': {
                          backgroundColor: 'alternate.light',
                        },
                      }}
                      onClick={() => handleOfferPopperChange()}
                    >
                      <Icon sx={{ color: 'alternate.main' }}>drafts</Icon>
                      <Typography> Offer candidate</Typography>
                    </Box>
                    <Box
                      display="flex"
                      alignItems="center"
                      padding={2}
                      columnGap={2}
                      sx={{
                        cursor: 'pointer',
                        '&:hover': {
                          backgroundColor: 'light-error.main',
                        },
                      }}
                      onClick={() => handleRejectPopperChange()}
                    >
                      <Icon sx={{ color: 'error.main' }}>highlight_off</Icon>
                      <Typography sx={{ color: 'error.main' }}> Reject</Typography>
                    </Box>
                  </Box>
                </Fade>
              )}
            </Popper>
          </Box>
        </Box>

        {rejectCandidateModalState.isOpen && (
          <RejectCandidateModal
            open={rejectCandidateModalState.isOpen}
            onClose={rejectCandidateModalState.handleClose}
            isLoading={updateCandidateIsLoading}
            onClick={() => updateCandidateMutate({ job_ad_candidate_status_id: 6 })}
            isError={updateCandidateIsError}
          />
        )}
        {offerCandidateModalState.isOpen && (
          <OfferCandidateModal
            open={offerCandidateModalState.isOpen}
            onClose={offerCandidateModalState.handleClose}
            isLoading={updateCandidateIsLoading}
            onClick={() => updateCandidateMutate({ job_ad_candidate_status_id: 4 })}
            isError={updateCandidateIsError}
          />
        )}
      </>
      // <Box display="flex" justifyContent="center" sx={{ width: '98%' }}>
      //   {revertIsLoading ? (
      //     <Box
      //       display="flex"
      //       justifyContent="center"
      //       bgcolor="default-background.main"
      //       sx={{
      //         width: '100%',
      //       }}
      //       py={1.5}
      //       px={2}
      //     >
      //       <CircularProgress color="alternate" size={25} />
      //     </Box>
      //   ) : (
      //     <Box
      //       display="flex"
      //       justifyContent="space-between"
      //       bgcolor="default-background.main"
      //       sx={{
      //         width: '100%',
      //       }}
      //       py={1.5}
      //       px={2}
      //     >
      //       <Typography
      //         display="flex"
      //         alignItems="center"
      //         variant="body1"
      //         color="light-gray-text.main"
      //         columnGap={1}
      //       >
      //         <Icon sx={{ color: 'positive.main' }}>check_circle_icon</Icon>
      //         Shortlisted
      //       </Typography>
      //       <Typography
      //         variant="body1"
      //         color="alternate.main"
      //         onClick={() => revertMutate(id)}
      //         sx={{
      //           textDecoration: 'underline',
      //           cursor: 'pointer',
      //         }}
      //       >
      //         Revert
      //       </Typography>
      //     </Box>
      //   )}
      // </Box>
    )
}

export default DrawerHeaderButtonState

const RejectCandidateModal = ({ open, onClose, isLoading, onClick, isError }) => (
  <AdxInfoModal
    variant={'error'}
    modalWidth={600}
    muiIcon="cancel"
    open={open}
    onClose={onClose}
    iconColor="error.main"
    title="Are you sure you want to reject this candidate?"
    subtitle="You won't be able to revert your action, and the candidate will be moved to the 'rejected' tab."
    footerButtons
    firstBtnLabel={'Move to rejected'}
    firstBtnHandle={onClick}
    secondBtnLabel={'Cancel'}
    secondBtnHandle={onClose}
  />
)

const NoEmailModal = ({ open, onClose }) => (
  <AdxInfoModal
    variant={'warning'}
    modalWidth={600}
    muiIcon="error"
    open={open}
    onClose={onClose}
    iconColor="yellow-01.main"
    title="Incomplete contact details"
    subtitle="The contact details must be filled in to shortlist the candidate."
    footerButtons
    firstBtnLabel={'Go back'}
    firstBtnHandle={onClose}
  />
)

const OfferCandidateModal = ({ open, onClose, isLoading, onClick, isError }) => (
  <AdxInfoModal
    modalWidth={600}
    muiIcon="drafts"
    open={open}
    onClose={onClose}
    iconColor="alternate.main"
    title="Are you sure you want to offer this candidate? "
    subtitle="By clicking 'Offer,' an email notification will be sent to the candidate, and the candidate will be moved to the 'Offer' tab."
    footerButtons
    firstBtnLabel={'Offer and notify candidate'}
    firstBtnHandle={onClick}
    secondBtnLabel={'Cancel'}
    secondBtnHandle={onClose}
  >
    {isError && (
      <Typography variant="body1" color="error.main">
        An error has occured. Please try again
      </Typography>
    )}
  </AdxInfoModal>
)

const HiredModal = ({ open, onClose, isLoading, onClick, isError }) => (
  <AdxInfoModal
    modalWidth={600}
    muiIcon="business_center"
    open={open}
    onClose={onClose}
    iconColor="alternate.main"
    title="Confirm your choice to hire this candidate."
    subtitle="By clicking 'Hire and notify candidate,' an email notification will be sent to the candidate, and the candidate will be moved to the 'Hired' tab."
    footerButtons
    firstBtnLabel={'Hire and notify candidate'}
    firstBtnHandle={onClick}
    secondBtnLabel={'Cancel'}
    secondBtnHandle={onClose}
  >
    {isError && (
      <Typography variant="body1" color="error.main">
        An error has occured. Please try again
      </Typography>
    )}
  </AdxInfoModal>
)
